@if (userForm) {
<form [formGroup]="userForm">
  <aw-form-field>
    <aw-form-field-label [required]="required()">
      {{ title() }}
    </aw-form-field-label>

    <!-- The hint and the error are tied to the field by id (aria-describedby), so a screen reader reads the limit with the
         field, and the error, which also announces itself (role="alert"), when it's shown. -->
    @let errors = userForm.controls['userInput'].touched ? userForm.controls['userInput'].errors : null;
    @let errorText = required() && errors?.['required'] ? title() + ' is required.' : errors?.['pattern'] ? patternMessage() : '';
    @let describedBy = ((maxCharacters() ? hintId : '') + (errorText ? ' ' + errorId : '')).trim() || null;

    @if (maxCharacters(); as max) {
    <aw-form-message [id]="hintId" type="info" [maximumCharacters]="max" [currentCharacterCount]="userForm.controls['userInput'].value ?? ''">
      Maximum characters is {{ max }}
    </aw-form-message>
    }

    @if (multiline()) {
    <!-- Wraps a long name instead of truncating it. Still one line of data, so Enter adds no line break. -->
    <textarea
      AwInput
      rows="3"
      [attr.aria-label]="title()"
      [attr.aria-describedby]="describedBy"
      [attr.aria-invalid]="errorText ? 'true' : null"
      [readOnly]="readOnly()"
      [placeholder]="placeholder()"
      formControlName="userInput"
      [attr.maxlength]="maxCharacters()"
      (keydown.enter)="$event.preventDefault()"
    ></textarea>
    } @else {
    <input
      AwInput
      [attr.aria-label]="title()"
      [attr.aria-describedby]="describedBy"
      [attr.aria-invalid]="errorText ? 'true' : null"
      [readOnly]="readOnly()"
      [placeholder]="placeholder()"
      type="text"
      formControlName="userInput"
      [attr.maxlength]="maxCharacters()"
    />
    }

    @if (errorText) {
    <aw-form-message [id]="errorId" type="error" role="alert">{{ errorText }}</aw-form-message>
    }
  </aw-form-field>
</form>
}
